<app-portal-layout>
  <h2 class="font-extrabold text-gray-800 mb-6 text-center px-4">
    <ng-container *ngIf="step === 'form'">
      <span
        >¡Ups! No pudimos encontrar tus datos, nos puedes ayudar a
        ingresarlos:</span
      ></ng-container
    >
    <ng-container *ngIf="step === 'confirmation'">
      <h2 class="text-3xl">Último check</h2>
      <p class="font-light text-xl mt-2">
        ¿Todo lo que escribiste está bien? Si sí,
        <strong class="font-bold">¡dale confirmar!</strong>
      </p>
    </ng-container>
  </h2>

  <form [formGroup]="activationForm">
    <!-- Step 1: Input Form -->
    <div *ngIf="step === 'form'" class="space-y-6">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Nombres</mat-label>
        <input type="text" formControlName="names" matInput maxlength="15" />
        @if (
          activationForm.get("names")?.invalid &&
          (activationForm.get("names")?.dirty ||
            activationForm.get("names")?.touched)
        ) {
          <mat-error>
            <ng-container
              *ngIf="activationForm.get('names')?.errors?.['required']"
              >El nombre es requerido.</ng-container
            >
            <ng-container
              *ngIf="activationForm.get('names')?.errors?.['maxlength']"
              >Máximo 15 caracteres.</ng-container
            >
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Apellidos</mat-label>
        <input type="text" formControlName="lastNames" matInput />
        @if (
          activationForm.get("lastNames")?.invalid &&
          (activationForm.get("lastNames")?.dirty ||
            activationForm.get("lastNames")?.touched)
        ) {
          <mat-error>Los apellidos son requeridos.</mat-error>
        }
      </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Tipo de documento</mat-label>
          <mat-select formControlName="documentType">
            @for (item of documentType; track $index) {
              <mat-option [value]="item.value">{{ item.name }}</mat-option>
            }
          </mat-select>
           @if (
          activationForm.get("documentType")?.invalid &&
          (activationForm.get("documentType")?.dirty ||
            activationForm.get("documentType")?.touched)
        ) {
          <mat-error>El tipo de documento es requerido</mat-error>
        }
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Número de documento</mat-label>
          <input type="text" formControlName="id" matInput maxlength="10" />
          <mat-hint>Solo números sin . ,</mat-hint>
          @if (
            activationForm.get("id")?.invalid &&
            (activationForm.get("id")?.dirty ||
              activationForm.get("id")?.touched)
          ) {
             @if (
          activationForm.get("id")?.invalid &&
          (activationForm.get("id")?.dirty || activationForm.get("id")?.touched)
        ) {
          @if (activationForm.get("id")?.getError("required")) {
            <mat-error>El documento es requerido</mat-error>
          }
          @if (activationForm.get("id")?.getError("maxLength")) {
            <mat-error>10 números máximo</mat-error>
          }
        }
          }
        </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Fecha de expedición</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [max]="maxDate"
          formControlName="expeditionDate"
        />
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if (
          activationForm.get("expeditionDate")?.invalid &&
          (activationForm.get("expeditionDate")?.dirty ||
            activationForm.get("expeditionDate")?.touched)
        ) {
          <mat-error>Fecha de expedición es obligatoria.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Fecha de Nacimiento</mat-label>
        <input
          matInput
          [matDatepicker]="picker1"
          [max]="maxDate"
          formControlName="birthDate"
        />
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker1"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        @if (
          activationForm.get("birthDate")?.invalid &&
          (activationForm.get("birthDate")?.dirty ||
            activationForm.get("birthDate")?.touched)
        ) {
          <mat-error>Fecha de nacimiento es obligatoria.</mat-error>
        }
      </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Correo electrónico</mat-label>
          <input type="email" formControlName="email" matInput />
          @if (
            activationForm.get("email")?.invalid &&
            (activationForm.get("email")?.dirty ||
              activationForm.get("email")?.touched)
          ) {
           @if (activationForm.get("email")?.getError("required")) {
            <mat-error>El correo electrónico es obligatorio</mat-error>
          }
          @if (activationForm.get("email")?.getError("email")) {
            <mat-error>El correo electrónico tiene formato inválido</mat-error>
          }
          }
        </mat-form-field>
        <div class="w-full flex justify-center">
          <button
            class="bg-red-500 w-[200px] uppercase text-white rounded-full p-4 font-extrabold text-xl disabled:opacity-50"
            type="button"
            [disabled]="activationForm.invalid"
            (click)="handleNext()"
          >
            Continuar
          </button>
        </div>
      </div>
    

    <!-- Step 2: Confirmation Screen -->
    <div *ngIf="step === 'confirmation'" class="space-y-6">
  <div class="bg-gray-50 p-6 rounded-lg border border-gray-200 shadow-inner space-y-4">
    <div class="flex items-center justify-between pb-2 border-b border-gray-200">
      <span class="text-gray-600 font-medium text-sm md:text-lg">Nombres:</span>
      <div class="flex items-center gap-2">
        <ng-container *ngIf="!editMode['names']; else namesEdit">
          <span class="text-gray-900 text-sm md:text-lg font-semibold">{{
            activationForm.get("names")?.value || "N/A"
          }}</span>
          <button (click)="toggleEdit('names')" type="button" class="editBtn">
            <img src="./edit-btn.svg" alt="Edit Icon" />
          </button>
        </ng-container>
        <ng-template #namesEdit>
          <mat-form-field appearance="fill" class="w-full">
            <input
              matInput
              type="text"
              formControlName="names"
              id="edit-names"
              (blur)="toggleEdit('names')"
            />
          </mat-form-field>
        </ng-template>
      </div>
    </div>

    <div class="flex items-center justify-between pb-2 border-b border-gray-200">
      <span class="text-gray-600 font-medium text-sm md:text-lg">Apellidos:</span>
      <div class="flex items-center gap-2">
        <ng-container *ngIf="!editMode['lastNames']; else lastNamesEdit">
          <span class="text-gray-900 text-sm md:text-lg font-semibold">{{
            activationForm.get("lastNames")?.value || "N/A"
          }}</span>
          <button (click)="toggleEdit('lastNames')" type="button" class="editBtn">
            <img src="edit-btn.svg" alt="Edit Icon" />
          </button>
        </ng-container>
        <ng-template #lastNamesEdit>
          <mat-form-field appearance="fill" class="w-full">
            <input
              matInput
              type="text"
              formControlName="lastNames"
              id="edit-lastNames"
              (blur)="toggleEdit('lastNames')"
            />
          </mat-form-field>
        </ng-template>
      </div>
    </div>

    <div class="flex items-center justify-between pb-2 border-b border-gray-200">
      <span class="text-gray-600 font-medium text-sm md:text-lg">Tipo de documento:</span>
      <div class="flex items-center gap-2">
        <ng-container *ngIf="!editMode['documentType']; else documentTypeEdit">
          <span class="text-gray-900 text-sm md:text-lg font-semibold">{{
            activationForm.get("documentType")?.value || "N/A"
          }}</span>
          <button (click)="toggleEdit('documentType')" type="button" class="editBtn">
            <img src="edit-btn.svg" alt="Edit Icon" />
          </button>
        </ng-container>
        <ng-template #documentTypeEdit>
          <mat-form-field appearance="fill" class="w-full">
            <mat-select
              formControlName="documentType"
              id="edit-documentType"
              (blur)="toggleEdit('documentType')"
            >
              @for (item of documentType; track $index) {
                <mat-option [value]="item.value">{{
                  item.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </ng-template>
      </div>
    </div>

    <div class="flex items-center justify-between pb-2 border-b border-gray-200">
      <span class="text-gray-600 font-medium text-sm md:text-lg">Número de documento:</span>
      <div class="flex items-center gap-2">
        <ng-container *ngIf="!editMode['id']; else idEdit">
          <span class="text-gray-900 text-sm md:text-lg font-semibold">{{
            activationForm.get("id")?.value || "N/A"
          }}</span>
          <button (click)="toggleEdit('id')" type="button" class="editBtn">
            <img src="edit-btn.svg" alt="Edit Icon" />
          </button>
        </ng-container>
        <ng-template #idEdit>
          <mat-form-field appearance="fill" class="w-full">
            <input
              matInput
              type="text"
              formControlName="id"
              id="edit-id"
              (blur)="toggleEdit('id')"
            />
          </mat-form-field>
        </ng-template>
      </div>
    </div>

    <div class="flex items-center justify-between pb-2 border-b border-gray-200">
      <span class="text-gray-600 font-medium text-sm md:text-lg">Fecha de expedición:</span>
      <div class="flex items-center gap-2">
        <ng-container *ngIf="!editMode['expeditionDate']; else expeditionDateEdit">
          <span class="text-gray-900 text-sm md:text-lg font-semibold">{{
            activationForm.get("expeditionDate")?.value | date
          }}</span>
          <button (click)="toggleEdit('expeditionDate')" type="button" class="editBtn">
            <img src="edit-btn.svg" alt="Edit Icon" />
          </button>
        </ng-container>
        <ng-template #expeditionDateEdit>
          <mat-form-field appearance="fill" class="w-full">
            <input
              matInput
              [matDatepicker]="pickerExp"
              [max]="maxDate"
              formControlName="expeditionDate"
              id="edit-expeditionDate"
              (dateInput)="toggleEdit('expeditionDate')"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="pickerExp"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerExp></mat-datepicker>
          </mat-form-field>
        </ng-template>
      </div>
    </div>

    <div class="flex items-center justify-between pb-2 border-b border-gray-200">
      <span class="text-gray-600 font-medium text-sm md:text-lg">Fecha de Nacimiento:</span>
      <div class="flex items-center gap-2">
        <ng-container *ngIf="!editMode['birthDate']; else birthDateEdit">
          <span class="text-gray-900 text-sm md:text-lg font-semibold">{{
            activationForm.get("birthDate")?.value | date
          }}</span>
          <button (click)="toggleEdit('birthDate')" type="button" class="editBtn">
            <img src="edit-btn.svg" alt="Edit Icon" />
          </button>
        </ng-container>
        <ng-template #birthDateEdit>
          <mat-form-field appearance="fill" class="w-full">
            <input
              matInput
              [matDatepicker]="pickerBirth"
              [max]="maxDate"
              formControlName="birthDate"
              id="edit-birthDate"
              (dateInput)="toggleEdit('birthDate')"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="pickerBirth"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerBirth></mat-datepicker>
          </mat-form-field>
        </ng-template>
      </div>
    </div>

    <div class="flex items-center justify-between pb-2 border-b border-gray-200">
      <span class="text-gray-600 font-medium text-sm md:text-lg">Correo Electrónico:</span>
      <div class="flex items-center gap-2">
        <ng-container *ngIf="!editMode['email']; else emailEdit">
          <span class="text-gray-900 text-sm md:text-lg font-semibold">{{
            activationForm.get("email")?.value || "N/A"
          }}</span>
          <button (click)="toggleEdit('email')" type="button" class="editBtn">
            <img src="edit-btn.svg" alt="Edit Icon" />
          </button>
        </ng-container>
        <ng-template #emailEdit>
          <mat-form-field appearance="fill" class="w-full">
            <input
              matInput
              type="email"
              formControlName="email"
              id="edit-email"
              (blur)="toggleEdit('email')"
            />
          </mat-form-field>
        </ng-template>
      </div>
    </div>
  </div>

   @if (isLoading) {
      <div class="w-full flex justify-center p-4">
        <mat-spinner></mat-spinner>
      </div>
    }@else{ 
      <div class="flex justify-center gap-4 mt-6">
        <button
          (click)="onSubmit()"
          [disabled]="!activationForm.valid"
          class="bg-red-500 w-[200px] uppercase text-white rounded-full p-4 font-extrabold text-xl"
          type="submit"
        >
          Confirmar
        </button>
      </div>
    }
</div>
  </form>
</app-portal-layout>
